// Serviço para consulta de CEP via ViaCEP
import { getAsaasConfig } from '../config/asaas';

export const viaCepService = {
  searchCep: async (cep) => {
    try {
      console.log('Iniciando busca do CEP:', cep);
      const cleanCep = cep.replace(/[^\d]/g, '');
      console.log('CEP limpo:', cleanCep);

      // Usando URL com HTTPS
      const url = `https://viacep.com.br/ws/${cleanCep}/json`;
      console.log('URL da requisição:', url);

      const response = await fetch(url);
      console.log('Status da resposta:', response.status);
      
      if (!response.ok) {
        console.error('Resposta não ok:', response.status, response.statusText);
        throw new Error('CEP inválido');
      }

      const data = await response.json();
      console.log('Dados recebidos:', data);

      // Se o serviço retornar erro: true
      if (data.erro) {
        throw new Error('CEP não encontrado');
      }

      const result = {
        rua: data.logradouro || '',
        cidade: data.localidade || '',
        estado: data.uf || '',
        complemento: data.complemento || ''
      };

      console.log('Dados formatados:', result);
      return result;

    } catch (error) {
      console.error('Erro completo:', {
        message: error.message,
        stack: error.stack,
        error
      });
      
      // Retorna o erro específico ou um erro genérico
      throw new Error(error.message || 'Erro ao buscar CEP. Tente novamente.');
    }
  }
};

// Serviço para envio de dados para API SGF
export const sgfService = {
  sendFiliada: async (formData) => {
    try {
      console.log('Enviando dados para API SGF:', formData);

      const sanitizeDigits = (value = '') => value.replace(/[^\d]/g, '');

      // Preparar os dados no formato esperado pela API (inclui campos do Asaas quando disponíveis)
      const payload = {
        // Identificação
        nome_fantasia: formData.nome_fantasia || '',
        razao_social: formData.razao_social || formData.nome_fantasia || '',
        cnpj: sanitizeDigits(formData.cnpj),

        // Emails
        email: formData.email || formData.email_responsavel || '',
        email_contato: formData.email_contato || formData.email_responsavel || '',
        email_financeiro: formData.email_financeiro || '',

        // Telefones
        telefone: (formData.telefone || formData.telefone_residencial || '').replace(/[^\d]/g, ''),
        telefone_celular: (formData.telefone_celular || formData.celular_zap_responsavel || '').replace(/[^\d]/g, ''),
        celular_zap_responsavel: (formData.celular_zap_responsavel || formData.telefone_celular || '').replace(/[^\d]/g, ''),

        // Endereço
        cep: sanitizeDigits(formData.cep),
        rua: formData.rua || '',
        numero: formData.numero || '',
        complemento: formData.complemento || formData.end_complemento || '',
        end_complemento: formData.end_complemento || formData.complemento || '',
        bairro: formData.bairro || '',
        cidade: formData.cidade || '',
        estado: formData.estado || '',

        // Rede/identidade visual
        website: formData.website || '',
        instagram: formData.instagram || '',
        facebook: formData.facebook || '',
        logotipo: formData.logotipo || '',

        // Responsável
        responsavel_nome: formData.responsavel_nome || formData.nome_responsavel || '',
        responsavel_email: formData.responsavel_email || formData.email_responsavel || '',
        cargo_responsavel: formData.cargo_responsavel || '',

        // Descrição e serviços
        descricao_empresa: formData.descricao_empresa || formData.breve_descricao || '',
        produtos_servicos: formData.produtos_servicos || formData.filiada_produtos_servicos || '',

        // Flags e financeiros
        is_startup: Boolean(formData.is_startup),
        dia_vencimento: formData.dia_vencimento || 20,
        status: formData.status || 'ativo',
        observacoes: formData.observacoes || 'Cadastro via site externo',

        // Campos relacionados ao Asaas/planos (opcionais)
        asaas_customer_id: formData.asaas_customer_id || undefined,
        asaas_subscription_id: formData.asaas_subscription_id || undefined,
        plan_id: formData.plan_id || undefined
      };

      console.log('Payload formatado:', payload);
      console.log('Campos de endereço no payload:', {
        cep: payload.cep,
        rua: payload.rua,
        numero: payload.numero,
        complemento: payload.complemento,
        cidade: payload.cidade,
        estado: payload.estado
      });

      // Obter variáveis de ambiente
      const apiKey = process.env.REACT_APP_APIKEY;
      const urlBase = process.env.REACT_APP_URL_BASE;

      if (!apiKey || !urlBase) {
        throw new Error('Configuração de API não encontrada. Verifique as variáveis de ambiente.');
      }

  // Garantir que usamos o path /api/external/filiadas conforme o exemplo em docs/prompts/filiadas.txt
  // Se a variável REACT_APP_URL_BASE já contém '/api' (ex: 'https://host/api'), não duplicamos.
  const baseIncludesApi = /\/api(\/|$)/i.test(urlBase);
  const url = baseIncludesApi ? `${urlBase.replace(/\/$/, '')}/external/filiadas` : `${urlBase.replace(/\/$/, '')}/api/external/filiadas`;
      console.log('URL da requisição:', url);

      let response;
      try {
        response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': apiKey
          },
          body: JSON.stringify(payload)
        });
      } catch (networkError) {
        // Falha de rede (por exemplo: API offline) — salvar localmente para retry
        console.warn('Falha de rede ao enviar para SGF, salvando localmente para retry:', networkError.message);
        try {
          const pendingKey = 'sgf_pending_filiadas';
          const pending = JSON.parse(localStorage.getItem(pendingKey) || '[]');
          const item = { id: `pending_${Date.now()}`, payload, createdAt: new Date().toISOString() };
          pending.push(item);
          localStorage.setItem(pendingKey, JSON.stringify(pending));
          return { savedOffline: true, item };
        } catch (e) {
          console.error('Erro ao salvar pending_filiada no localStorage:', e);
          throw networkError;
        }
      }

      console.log('Status da resposta:', response.status);

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        console.error('Erro na resposta:', errorData);
        throw new Error(`Erro ao enviar dados: ${response.status} - ${errorData.message || response.statusText}`);
      }

      const data = await response.json();
      console.log('Dados recebidos da API:', data);

      return data;

    } catch (error) {
      console.error('Erro ao enviar para API SGF:', {
        message: error.message,
        stack: error.stack,
        error
      });
      
      throw new Error(error.message || 'Erro ao enviar dados. Tente novamente.');
    }
  },

  // Tenta reenviar itens pendentes armazenados no localStorage
  retryPending: async () => {
    const pendingKey = 'sgf_pending_filiadas';
    const pendingRaw = localStorage.getItem(pendingKey);
    if (!pendingRaw) return { retried: 0 };

    let pending;
    try {
      pending = JSON.parse(pendingRaw || '[]');
    } catch (e) {
      console.error('Erro ao parsear pending_filiadas:', e);
      localStorage.removeItem(pendingKey);
      return { retried: 0 };
    }

    if (!pending.length) return { retried: 0 };

    const apiKey = process.env.REACT_APP_APIKEY;
    const urlBase = process.env.REACT_APP_URL_BASE;
    if (!apiKey || !urlBase) {
      throw new Error('Configuração de API não encontrada. Verifique as variáveis de ambiente.');
    }

  // Mesmo comportamento de montagem de URL para retryPending
  const baseIncludesApi = /\/api(\/|$)/i.test(urlBase);
  const url = baseIncludesApi ? `${urlBase.replace(/\/$/, '')}/external/filiadas` : `${urlBase.replace(/\/$/, '')}/api/external/filiadas`;
    let retried = 0;
    const stillPending = [];

    for (const item of pending) {
      try {
        const res = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': apiKey
          },
          body: JSON.stringify(item.payload)
        });

        if (res.ok) {
          retried += 1;
          console.log('Pending item enviado com sucesso:', item.id);
        } else {
          console.warn('Pending item não enviado (status):', res.status, item.id);
          stillPending.push(item);
        }
      } catch (err) {
        console.warn('Erro ao reenviar pending item, mantendo na lista:', item.id, err.message);
        stillPending.push(item);
      }
    }

    if (stillPending.length) {
      localStorage.setItem(pendingKey, JSON.stringify(stillPending));
    } else {
      localStorage.removeItem(pendingKey);
    }

    return { retried, remaining: stillPending.length };
  }
};

// Serviço para integração com Asaas
export const asaasService = {
  createCustomer: async (formData) => {
    try {
      console.log('Criando cliente no Asaas:', formData);
      
      const sanitizeDigits = (value = '') => value.replace(/[^\d]/g, '');

      // Preparar os dados do cliente no formato esperado pela API Asaas
      const payload = {
        name: formData.razao_social || formData.nome_fantasia || '',
        email: formData.email_responsavel || '',
        phone: sanitizeDigits(formData.celular_zap_responsavel),
        mobilePhone: sanitizeDigits(formData.celular_zap_responsavel),
        cpfCnpj: sanitizeDigits(formData.cnpj),
        postalCode: sanitizeDigits(formData.cep),
        address: formData.rua || '',
        addressNumber: formData.numero || '',
        complement: formData.complemento || '',
        province: formData.bairro || '',
        externalReference: formData.cnpj || '',
        notificationDisabled: false,
        additionalEmails: formData.email_responsavel || '',
        municipalInscription: '',
        stateInscription: '',
        observations: `Empresa: ${formData.nome_fantasia || ''}\nResponsável: ${formData.nome_responsavel || ''}\nCargo: ${formData.cargo_responsavel || ''}`
      };

      console.log('Payload do Asaas:', payload);

      // Obter variáveis de ambiente do Asaas
      const config = getAsaasConfig();
      const asaasUrl = config.url;
      const asaasApiKey = config.apiKey;

      console.log('🔑 Configurações Asaas:', {
        url: asaasUrl,
        apiKeyPresent: !!asaasApiKey,
        apiKeyLength: asaasApiKey?.length,
        apiKeyPrefix: asaasApiKey?.substring(0, 10) + '...'
      });

      if (!asaasUrl || !asaasApiKey) {
        console.error('❌ Variáveis de ambiente faltando:', { asaasUrl, hasApiKey: !!asaasApiKey });
        throw new Error('Configuração do Asaas não encontrada. Verifique as variáveis de ambiente REACT_APP_URL_ASAAS e REACT_APP_APIKEY_ASAAS');
      }

      const url = `${asaasUrl}/customers`;
      console.log('📡 URL da requisição Asaas:', url);
      console.log('📦 Payload sendo enviado:', JSON.stringify(payload, null, 2));

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'access_token': asaasApiKey
        },
        body: JSON.stringify(payload)
      });

      console.log('📊 Status da resposta Asaas:', response.status);
      console.log('📋 Headers da resposta:', Object.fromEntries(response.headers.entries()));

      const responseText = await response.text();
      console.log('📄 Resposta bruta:', responseText);

      if (!response.ok) {
        let errorData;
        try {
          errorData = JSON.parse(responseText);
        } catch (e) {
          errorData = { message: responseText };
        }
        console.error('❌ Erro na resposta Asaas:', errorData);
        throw new Error(`Erro ao criar cliente no Asaas: ${response.status} - ${JSON.stringify(errorData)}`);
      }

      const data = JSON.parse(responseText);
      console.log('✅ Cliente criado no Asaas:', data);

      // Salvar ID do cliente no localStorage
      if (data.id) {
        localStorage.setItem('asaas_customer_id', data.id);
        console.log('💾 ID do cliente salvo no localStorage:', data.id);
      }

      return data;

    } catch (error) {
      console.error('Erro ao criar cliente no Asaas:', {
        message: error.message,
        stack: error.stack,
        error
      });
      
      throw new Error(error.message || 'Erro ao criar cliente. Tente novamente.');
    }
  },

  createInstallmentPayment: async (customerId, totalValue = 1198.00, installments = 12, successUrl) => {
    try {
      console.log('Criando cobrança parcelada no Asaas:', { customerId, totalValue, installments });
      
      const config = getAsaasConfig();
      const asaasUrl = config.url;
      const asaasApiKey = config.apiKey;

      if (!asaasUrl || !asaasApiKey) {
        throw new Error('Configuração do Asaas não encontrada.');
      }

      const today = new Date().toISOString().split('T')[0];

      const payload = {
        customer: customerId,
        billingType: 'CREDIT_CARD',
        description: 'Startup Plano Anual (12x no cartão)',
        value: totalValue,
        installmentCount: installments,
        dueDate: today,
        externalReference: 'sgf-startup-12x',
        postalService: false,
        callback: {
          successUrl: successUrl
        }
      };

      console.log('Payload da cobrança parcelada:', payload);

      const url = `${asaasUrl}/payments`;
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'access_token': asaasApiKey
        },
        body: JSON.stringify(payload)
      });

      console.log('Status da resposta Asaas (parcelado):', response.status);

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        console.error('Erro na resposta Asaas:', errorData);
        throw new Error(`Erro ao criar cobrança: ${response.status} - ${errorData.message || response.statusText}`);
      }

      const data = await response.json();
      console.log('Cobrança parcelada criada:', data);

      return data;

    } catch (error) {
      console.error('Erro ao criar cobrança parcelada:', error);
      throw new Error(error.message || 'Erro ao criar cobrança. Tente novamente.');
    }
  },

  createSinglePayment: async (customerId, value = 990.00, successUrl) => {
    try {
      console.log('Criando cobrança à vista no Asaas:', { customerId, value });
      
      const config = getAsaasConfig();
      const asaasUrl = config.url;
      const asaasApiKey = config.apiKey;

      if (!asaasUrl || !asaasApiKey) {
        throw new Error('Configuração do Asaas não encontrada.');
      }

      const today = new Date().toISOString().split('T')[0];

      const payload = {
        customer: customerId,
        billingType: 'CREDIT_CARD',
        value: value,
        description: 'Plano anual (1x no cartão)',
        dueDate: today,
        externalReference: 'sgf-plano-anual-1x',
        postalService: false,
        callback: {
          successUrl: successUrl
        }
      };

      console.log('Payload da cobrança à vista:', payload);

      const url = `${asaasUrl}/payments`;
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'access_token': asaasApiKey
        },
        body: JSON.stringify(payload)
      });

      console.log('Status da resposta Asaas (à vista):', response.status);

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        console.error('Erro na resposta Asaas:', errorData);
        throw new Error(`Erro ao criar cobrança: ${response.status} - ${errorData.message || response.statusText}`);
      }

      const data = await response.json();
      console.log('Cobrança à vista criada:', data);

      return data;

    } catch (error) {
      console.error('Erro ao criar cobrança à vista:', error);
      throw new Error(error.message || 'Erro ao criar cobrança. Tente novamente.');
    }
  }
};

export default viaCepService;
